import { render } from "./LogoutButton.vue?vue&type=template&id=4c9b1e66&ts=true"
import script from "./LogoutButton.vue?vue&type=script&lang=ts"
export * from "./LogoutButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__